module.exports = __webpack_public_path__ + "static/akzent-f-en-56348a05cde154595616aaa18785df17.png";